export const STUDENT_INTERNSHIP_FORM_ID = 4984620;
export const FORM_IDS = [STUDENT_INTERNSHIP_FORM_ID];

type FormParameters = Record<string, string>;

export const getStudentInternshipParameters = ({
  studentId = '',
  studentEmail = '',
  studentFirstName = '',
  studentLastName = '',
  pathId = '',
  pathTitle = '',
}: DOMStringMap) => ({
  tfa_2: studentId,
  tfa_3: studentEmail,
  tfa_4: studentFirstName,
  tfa_5: studentLastName,
  tfa_6: pathId,
  tfa_7: pathTitle,
});

export const getLinkParameters = (formId: number, dataset: DOMStringMap): FormParameters | null => {
  switch (formId) {
    case STUDENT_INTERNSHIP_FORM_ID:
      return getStudentInternshipParameters(dataset);
    default:
      return null;
  }
};
